<template>
  <div class="u-center flex-col mx-auto w-72 sm:w-auto space-y-3.75 justify-center flex-grow py-6" style="max-width: 748px">
    <template v-if="error.statusCode >= 400 && error.statusCode <= 499">
      <img src="https://assets.onedio.com/asset-1c0421dd854375d0ce955de16e09ce28/images/pages/error/404.gif" />
      <p class="text-center leading-tight text-sm sm:text-base" style="color: #8a8a8a">
        <strong class="block sm:inline mb-3.75 text-lg text-primary-100 sm:text-current">{{ $t('errorpage.text-1') }}</strong>
        {{ $t('errorpage.text-2') }}
        <br />
        {{ $t('errorpage.text-3') }}
      </p>
    </template>
    <template v-else-if="error.statusCode >= 500 && error.statusCode <= 599">
      <img src="https://assets.onedio.com/asset-1c0421dd854375d0ce955de16e09ce28/images/pages/error/500.gif" />
      <p class="text-center leading-tight text-sm sm:text-base" style="color: #8a8a8a">
        <strong class="block sm:inline mb-3.75 text-lg text-primary-100 sm:text-current">{{ $t('errorpage.text-4') }}</strong>
        {{ $t('errorpage.text-5') }}
        <br />
        {{ $t('errorpage.text-6') }}
      </p>
    </template>
    <OLink pure class="h-12 m-2.5 u-center bg-o-blue w-full text-white border-b-2" style="max-width: 260px; border-color: #315577" href="/">
      {{ $t('errorpage.home-button') }}
    </OLink>
  </div>
</template>
<script>
import { defineComponent, useContext } from '@nuxtjs/composition-api';
import { OLink } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OLink },
  props: ['error'],
  setup({ error }) {
    if (error.statusCode > 400 && error.statusCode < 500) {
      const { $cache } = useContext();
      $cache('public, max-age=30');
      if (process.client) {
        setTimeout(function () {
          location.replace('/');
        }, 5000);
      }
    }
  },
});
</script>
